export default {"src":"/_next/static/media/icClose.fa73db69.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};